import * as React from 'react'
import styled from 'styled-components'
import { VideoData } from '../../../interfaces'
import {
  Button,
  ButtonGroup,
  createMuiTheme,
  createStyles,
  LinearProgress,
  ThemeProvider,
  useMediaQuery,
  withStyles,
} from '@material-ui/core'
import { useSubscription } from '@apollo/client'
import {
  BALANCE_SUBSCRIPTION,
  PRIMARY_SUBSCRIPTION,
  SECONDARY_SUBSCRIPTION,
} from '../../../graphql/graphql-queries'
import isMobileCalendar from '../../../utils/isMobile'
import { Query_Root } from '../../../graphql/indexer-graphql-types'
import useDate from '../../../utils/useDate'
import {
  // AccountMeta,
  // Keypair,
  LAMPORTS_PER_SOL,
  // PublicKey,
  // sendAndConfirmRawTransaction,
  // Transaction,
} from '@solana/web3.js'
import { useAtom } from 'jotai'
import { rwSolPriceAtom } from '../../../atoms/WalletName'
import { animated, useSpring } from 'react-spring'
// import { fbGetUserMetadata } from '../../../data/FirebaseEnrich'
// import {
//   crossmintBuyAtom,
//   PurchaseType,
//   // SecondaryAction,
// } from '../../../atoms/Wallet'
// import { getShortenedAddress } from '../../../utils/address'
// import { rwBuySellDialogAtom } from '../../../atoms/SecondaryDialog'
// import { useWallet } from '@solana/wallet-adapter-react'
import useAuth from '../../../hooks/auth'
// import { TokenProgram } from '../../../program'
// import { solanaConnection } from '../../../data/Connection'
// import { Base64 } from 'js-base64'
// import { txSigner } from '../../../data/TxSigner'
// import { network } from '../../../metadata/2021-12-22/primitives/network'
// import { captureException } from '@sentry/nextjs'
import { Popover, useToasts } from '@geist-ui/react'
// import { useTxToast } from '../../../hooks/toast'
// import { useConnectModal } from '../../../hooks/walletModal'
import { getTimeRemaining } from '../../../utils/time'
import useInterval from '../../../utils/useInterval'
import moment from 'moment'
import HintLabel from '../../global/HintLabel'
import { buildUrl, CalendarEvent } from '../../../utils/calendar'
import { db } from '../../../data/FirebaseUtils'
import { Apple } from '@material-ui/icons'
import { Calendar, ChevronUpCircle } from '@geist-ui/react-icons'
// import { BN } from '@project-serum/anchor'
// import log from '../../../events/log'
// import { ClickListForSaleEvent, ClickSellEvent } from '../../../events/revenue_events'
import { Skeleton } from '@material-ui/lab'

type EditionsDetailsProps = {
  video: VideoData
}

const OuterDiv = styled(animated.div)<{ sticky: boolean }>`
  z-index: 100 !important;
  border-radius: 15px;
  overflow: hidden;
  background: #101010;
  width: calc(100% + 2px);
  margin-left: -16px;
  height: 300px;
  position: fixed;
  bottom: -224px;

  @media (min-width: 43em) {
    margin-left: -26px;
    height: 309px;
  }

  @media (min-width: 62em) {
    z-index: 1 !important;
    position: ${(props) => (props.sticky ? `fixed` : `relative`)};
    margin-left: 0;
    bottom: unset;
    margin-top: ${(props) => (props.sticky ? `-25px` : `0`)};
    margin-bottom: ${(props) => (props.sticky ? `0` : `25px`)};
    width: 327px;
    height: 312px;
  }

  @media (min-width: 75em) {
    width: 352px;
    height: 312px;
  }
`

const InnerDiv = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 2;
  background: #101010; //linear-gradient(rgb(35, 35, 35), rgb(20, 20, 20));
  border-radius: 15px 15px 0 0;
  padding: 15px;
  /* margin-top: 15px; */
  height: fit-content;
  border-color: #999;
  border-width: 1px;
  border-style: solid;

  @media (min-width: 43em) {
    padding: 20px;
    margin-top: 0px;
    margin-bottom: 25px;
  }

  @media (min-width: 62em) {
    border-radius: 15px 15px 15px 15px;
    border-color: #999;
    border-width: 1px;
    border-style: solid;
  }
`

const Title = styled.div`
  color: white;
  font-size: 12px;
  font-weight: 500;
  text-align: left;

  @media (min-width: 43em) {
    font-size: 14px;
  }
`

const Ends = styled.div<{ starts?: boolean }>`
  color: ${(props) => (props.starts ? `rgb(48, 209, 88)` : `rgb(255, 69, 58)`)};
  font-size: 12px;
  font-weight: 600;
  text-align: left;

  @media (min-width: 43em) {
    font-size: 14px;
  }
`

const InfoDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 5px;
`

const MainStat = styled.div<{ discount?: boolean }>`
  color: ${(props) => (props.discount ? `rgb(48, 209, 88)` : `white`)};
  font-size: 20px;
  font-weight: 700;
  text-align: left;

  @media (min-width: 43em) {
    font-size: 18px;
  }
`

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #444;
`

const TopDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
`

const TitleDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;

  @media (min-width: 62em) {
    justify-content: space-between;
  }
`

const HeaderDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const NextLvl = styled.div`
  color: white;
  font-size: 12px;
  font-weight: 500;
  text-align: right;
`

const TotalDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 15px 0 0 0;
`

const PriceDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`

const Dollars = styled.div<{ discount?: boolean }>`
  color: ${(props) => (props.discount ? `rgb(48, 209, 88)` : `#cdcdcd`)};
  font-size: 12px;
  font-weight: 500;
  text-align: left;
  margin-top: -2px;
`

const ProgressDiv = styled.div`
  display: flex;
  flex-direction: column-reverse;
  justify-content: flex-end;
  /* align-items: flex-end; */
  gap: 10px;
  margin: 15px 0;
  width: 100%;
`

const ActionsDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
`

const BuyButton = styled(animated.div)<{ disabled?: boolean }>`
  background: ${(props) => (props.disabled ? '#323232' : '#FFF')};
  width: 100%;
  border-radius: 10px;
  color: ${(props) => (props.disabled ? '#cdcdcd' : 'black')};
  text-align: center;
  align-items: center;
  font-weight: 700;
  font-size: 15px;
  padding: 10px;
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};

  @media (min-width: 62em) {
    font-size: 16px;
  }
`

const TopLeftDiv = styled.div`
  position: relative;
  /* width: 100%; */
  /* grid-template: 1fr / 1fr;
  place-items: flex-end normal;
  & > * {
    grid-column: 1 / 1;
    grid-row: 1 / 1;
  } */
`

const MobileBuy = styled(animated.div)`
  background: none;
  /* width: 20%; */
  border-radius: 10px;
  color: white;
  border: 1px solid white;
  text-align: center;
  align-items: center;
  font-weight: 700;
  font-size: 14px;
  padding: 10px 20px;
  width: fit-content;
  cursor: pointer;

  @media (min-width: 62em) {
    display: none;
  }
`

const ChevronDiv = styled(animated.div)`
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;

  @media (min-width: 62em) {
    display: none;
  }
`

const SellButton = styled(animated.div)`
  background: none;
  width: 30%;
  border-radius: 10px;
  color: white;
  border: 1px solid white;
  text-align: center;
  align-items: center;
  font-weight: 700;
  font-size: 15px;
  padding: 10px;
  cursor: pointer;

  @media (min-width: 62em) {
    font-size: 16px;
  }
`

const BorderLinearProgress = withStyles(() =>
  createStyles({
    root: {
      height: 20,
      borderRadius: 13,
    },
    colorPrimary: {
      backgroundColor: '#444',
    },
    bar: {
      borderRadius: 13,
      background: 'white',
    },
  })
)(LinearProgress)

const PopoverWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 225px;
`

const MenuItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  padding: 12px 20px;
  align-items: center;
  cursor: pointer;

  :hover {
    background: #232323;
  }
`

const MenuItemTitle = styled.div<{ color: string }>`
  font-weight: 400;
  color: ${(props) => props.color};
  font-size: 16px;
`

const theme = createMuiTheme({
  palette: {
    type: 'dark',
  },
})

const EditionsDetails = ({ video }: EditionsDetailsProps): JSX.Element => {
  const [quantity, setQuantity] = React.useState(1)
  const [scheduledTime, setScheduledTime] = React.useState<Date>()
  const [sticky, setSticky] = React.useState(false)
  const [price, setPrice] = useAtom(rwSolPriceAtom)
  const primaryData = useSubscription<Query_Root>(PRIMARY_SUBSCRIPTION, {
    variables: {
      mint: video.address,
    },
  }).data
  const secondaryData = useSubscription<Query_Root>(SECONDARY_SUBSCRIPTION, {
    variables: {
      mint: video.address,
    },
  }).data
  // const listings = useQuery<Query_Root>(LISTINGS_QUERY, {
  //   variables: {
  //     mint: video.address,
  //     offset: 0,
  //     limit: 1,
  //   },
  // })
  // const [buyHover, setBuyHover] = React.useState(false)
  // const [sellHover, setSellHover] = React.useState(false)
  // const [, crossmintBuy] = useAtom(crossmintBuyAtom)
  const [, setToast] = useToasts()
  // const showTxToast = useTxToast()
  // const [, crossmintSecondary] = useAtom(crossmintSecondaryAtom)
  // const wallet = useWallet()
  const { profile, isAuthenticated } = useAuth()
  // const [, setOpen] = useAtom(rwBuySellDialogAtom)
  // const setVisible = useConnectModal()
  const [startTime, setStartTime] = React.useState(
    scheduledTime ? getTimeRemaining(scheduledTime) : undefined
  )
  const isTablet = useMediaQuery('(max-width: 62em)')
  const [expand, setExpand] = React.useState(true)
  const primaryMint = primaryData?.mint[0]
  const secondaryMint = secondaryData?.mint[0]
  // const { metadataObject } = secondaryMint?.editionMetadata || {}
  // const { max } = metadataObject?.bidReceiptsAggregate?.aggregate || {}
  // const maxPrice = max?.price || 0
  const { min } = secondaryMint?.listingsWithTokenAggregate?.aggregate || {}
  const minPrice = min?.price || 0
  const { count } = secondaryMint?.listingsWithTokenAggregate?.aggregate || {}
  const { dropTime } = primaryMint?.dropTime || {}

  const now = useDate()

  const isLive = scheduledTime && scheduledTime <= now

  const hasEndTime = primaryMint?.milestones?.endTime !== undefined

  const [endTime, setEndTime] = React.useState(
    hasEndTime ? getTimeRemaining(new Date(primaryMint?.milestones?.endTime)) : undefined
  )
  const [visible, setCalendarVisible] = React.useState(false)
  const [hasAllowlist, setHasAllowlist] = React.useState(false)
  const [allowlistAmount, setAllowlistAmount] = React.useState(0)
  const [allowlistDiscount, setAllowlistDiscount] = React.useState<number | undefined>(undefined)
  const balanceData = useSubscription<Query_Root>(BALANCE_SUBSCRIPTION, {
    variables: {
      mint: video?.address ?? '',
      user: profile?.address ?? '',
    },
  }).data

  const balance = balanceData?.mint[0]?.tokenAccountsAggregate.aggregate?.sum?.amount

  useInterval(() => {
    if (scheduledTime) {
      const st = getTimeRemaining(scheduledTime)
      if (!(st.days <= 0 && st.hours <= 0 && st.minutes <= 0 && st.seconds < 0)) {
        setStartTime(st)
      } else {
        setStartTime({ days: 0, minutes: 0, hours: 0, seconds: 0 })
      }
    }
    if (primaryMint?.milestones?.endTime) {
      const et = getTimeRemaining(new Date(primaryMint?.milestones?.endTime))
      if (!(et.days <= 0 && et.hours <= 0 && et.minutes <= 0 && et.seconds < 0)) {
        setEndTime(et)
      } else {
        setEndTime({ days: 0, minutes: 0, hours: 0, seconds: 0 })
      }
    }
  }, 1000)

  const isEnded = endTime
    ? endTime.days <= 0 && endTime.hours <= 0 && endTime.minutes <= 0 && endTime.seconds <= 0
    : false

  const isMaxMilestone = primaryMint?.milestones?.nextMilestone
    ? primaryMint?.milestones?.nextMilestone == primaryMint?.editionMetadata?.maxSupply
    : true

  const isSoldOut = primaryMint?.supply === primaryMint?.editionMetadata?.maxSupply

  const isSticky = () => {
    const scrollTop = window.scrollY
    const sticky = scrollTop >= 25 ? true : false
    setSticky(sticky)
  }

  const buyHoverState = useSpring({
    // boxShadow: buyHover ? '0px 5px 25px rgba(255,255,255,0.2)' : '0px 0px 0px rgba(0,0,0,0)',
    // transform: buyHover ? `translate3d(0,-7%,0)` : `translate3d(0,0%,0)`,
    color: `#cdcdcd`,
    background: `#323232`,
    cursor: `not-allowed`,
    config: {
      mass: 1,
      tension: 170,
      friction: 26,
      velocity: 0,
    },
  })

  const sellHoverState = useSpring({
    color: `#cdcdcd`,
    background: `#323232`,
    cursor: `not-allowed`,
    config: {
      mass: 1,
      tension: 170,
      friction: 26,
      velocity: 0,
    },
  })

  const expandState = useSpring({
    bottom: expand ? `-224px` : `-5px`,
    config: {
      mass: 1,
      tension: 200,
      friction: 23,
      velocity: 0,
    },
  })

  const mobileBuyState = useSpring({
    opacity: !expand ? `0` : `100%`,
    config: {
      mass: 1,
      tension: 209,
      friction: 23,
      velocity: 0,
    },
  })

  const chevronState = useSpring({
    transform: !expand ? `rotateX(180deg)` : `rotateX(0deg)`,
    opacity: expand ? `0` : `100%`,
    config: {
      mass: 1,
      tension: 209,
      friction: 23,
      velocity: 0,
    },
  })

  // const processingToast = React.useCallback(
  //   async (text: string): Promise<void> => {
  //     setToast({
  //       text,
  //       type: 'warning',
  //     })
  //   },
  //   [setToast]
  // )

  React.useEffect(() => {
    setScheduledTime(new Date(dropTime))
  }, [dropTime])

  React.useEffect(() => {
    setScheduledTime(undefined)
    setEndTime(undefined)
    setQuantity(1)
  }, [video.address])

  React.useEffect(() => {
    setQuantity(1)
  }, [balance, primaryMint?.milestones?.nextMilestone])

  React.useEffect(() => {
    window.addEventListener('scroll', isSticky)
    return () => {
      window.removeEventListener('scroll', isSticky)
    }
  }, [])

  const getSolPrice = async (): Promise<void> => {
    const resp = await fetch(
      'https://api.coingecko.com/api/v3/simple/price?vs_currencies=usd&ids=solana'
    )
    const json = await resp.json()
    setPrice(json['solana']['usd'] as number)
  }

  React.useEffect(() => {
    if (price === 0) {
      getSolPrice()
    }
  }, [])

  // const buyEdition = async (discount?: number, maxAmt?: number): Promise<void> => {
  //   if (
  //     primaryMint &&
  //     video &&
  //     wallet &&
  //     wallet.connected &&
  //     wallet.publicKey &&
  //     provider &&
  //     wallet.signTransaction
  //   ) {
  //     try {
  //       if (localStorage.getItem('walletName') === '"Crossmint"') {
  //         const creator = await fbGetUserMetadata(video.created_by)
  //         crossmintBuy({
  //           video,
  //           creatorName: creator?.display_name ?? '',
  //           purchaseType: PurchaseType.PRIMARY,

  //           buyer: wallet.publicKey.toString(),
  //           seller: video.created_by,
  //           price: (
  //             (primaryMint.editionMetadata?.primarySalePrice ?? 0) / LAMPORTS_PER_SOL
  //           ).toFixed(2),
  //           priceLamports: primaryMint.editionMetadata?.primarySalePrice,
  //           tokenSize: quantity,
  //         })
  //         return
  //       }

  //       const mint = new PublicKey(video.address)
  //       const creatorPubKey = new PublicKey(video.created_by)
  //       const program = TokenProgram.getProgram(provider)
  //       const platformTreasury = await TokenProgram.getPlatformTreasuryAddress(program)
  //       const [metadata] = await TokenProgram.findMetadataAddress(mint)
  //       const platformSigner = await TokenProgram.getPlatformSignerAddress(program)
  //       const [tokenAccount] = await TokenProgram.findAssociatedTokenAccountAddress(
  //         mint,
  //         wallet.publicKey
  //       )
  //       const primaryReceipt = Keypair.generate()

  //       const transaction = new Transaction({ feePayer: wallet.publicKey })
  //       transaction.add(
  //         await program.methods
  //           .primarySale(
  //             quantity,
  //             discount ? new BN(Math.sqrt(discount * quantity)) : null,
  //             maxAmt ?? primaryMint?.editionMetadata?.maxSupply
  //           )
  //           .accounts({
  //             platformSigner,
  //             mint,
  //             metadata,
  //             platformTreasury,
  //             tokenAccount,
  //             primaryReceipt: primaryReceipt.publicKey,
  //           })
  //           .remainingAccounts([
  //             {
  //               pubkey: platformTreasury,
  //               isSigner: false,
  //               isWritable: true,
  //             },
  //             {
  //               pubkey: creatorPubKey,
  //               isSigner: false,
  //               isWritable: true,
  //             },
  //           ] as AccountMeta[])
  //           .instruction()
  //       )

  //       transaction.recentBlockhash = (await solanaConnection.getLatestBlockhash()).blockhash

  //       transaction.partialSign(primaryReceipt)

  //       const encoded = Base64.fromUint8Array(
  //         transaction.serialize({ requireAllSignatures: false, verifySignatures: true }),
  //         false
  //       )
  //       const adminSignedIx = await txSigner(encoded)

  //       const tx = Transaction.from(Base64.toUint8Array(adminSignedIx.tx_data))

  //       const signed = await wallet.signTransaction(tx)

  //       const fee = await tx.getEstimatedFee(solanaConnection)

  //       const walletBalance = await fetchBalance()

  //       if (walletBalance < fee + quantity * primaryMint.editionMetadata?.primarySalePrice) {
  //         setToast({
  //           text: `Whoops, you don't have enough SOL!`,
  //           type: 'error',
  //         })
  //         return
  //       }

  //       const serialized = signed.serialize()

  //       processingToast('Buying video NFT...')

  //       const hash = await sendAndConfirmRawTransaction(solanaConnection, serialized, {
  //         commitment: 'confirmed',
  //         preflightCommitment: 'confirmed',
  //       })

  //       showTxToast({
  //         nw:
  //           process.env.NEXT_PUBLIC_ENVIRONMENT === 'production'
  //             ? network.SOL_MAINNET
  //             : network.SOL_DEVNET,
  //         hash: hash,
  //         text: 'Congrats, you just bought this NFT!',
  //       })
  //     } catch (err) {
  //       console.error(err)
  //       setToast({
  //         text: `Oops, something went wrong (${err}). Please try again.`,
  //         type: 'error',
  //       })
  //       captureException(err)
  //     }
  //   } else {
  //     setVisible(true)
  //   }
  // }

  const changeVisible = (next: boolean): void => {
    setCalendarVisible(next)
  }

  const checkAllowlist = async (user: string): Promise<void> => {
    if (!isLive && dropTime && new Date(dropTime) > now) {
      const presaleDoc = await db.presales(video.address).doc(user).get()
      setHasAllowlist(presaleDoc.exists)
      if (presaleDoc.exists) {
        const amount = presaleDoc.data()?.amount ?? 1
        const price = presaleDoc.data()?.price ?? undefined
        setAllowlistAmount(amount)
        setAllowlistDiscount(price)
        setToast({
          text: `Congratulations, you are whitelisted! Claim ${amount} edition${
            amount === 1 ? '' : 's'
          }.`,
          type: 'success',
          delay: 5000,
        })
      } else {
        setAllowlistAmount(0)
        setAllowlistDiscount(undefined)
        setToast({
          text: `Looks like you aren't whitelisted for this video. Add it to your calendar to show up on time for the public sale.`,
          type: 'error',
          delay: 5000,
        })
      }
    }
  }

  React.useEffect(() => {
    if (isAuthenticated && profile && video.has_presale && !isLive) {
      checkAllowlist(profile.address)
    } else if (primaryMint?.editionMetadata?.primarySalePrice === 0) {
      setAllowlistAmount(5)
      setAllowlistDiscount(undefined)
    } else {
      setAllowlistAmount(0)
      setAllowlistDiscount(undefined)
    }
  }, [profile, isAuthenticated, video.address, primaryMint?.editionMetadata?.primarySalePrice])

  const calendarStyle = {
    width: '100%',
    height: '100%',
    // padding: '22px 0',
  }

  const openCalendarLink = (event: CalendarEvent, type: string, id: string): void => {
    const url = buildUrl(event, type, id)
    if (!isMobileCalendar() && (url.startsWith('data') || url.startsWith('BEGIN'))) {
      const filename = 'download.ics'
      const blob = new Blob([url], { type: 'text/calendar;charset=utf-8' })

      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } else {
      window.open(url, '_blank')
    }
    setCalendarVisible(false)
  }

  return (
    <OuterDiv sticky={sticky} style={isTablet ? expandState : {}}>
      {!startTime ? (
        <ThemeProvider theme={theme}>
          <Skeleton animation="wave" variant="rect" width={'100%'} height={'100%'} />
        </ThemeProvider>
      ) : (
        <InnerDiv>
          <TopDiv onClick={() => setExpand(!expand)}>
            <HeaderDiv>
              <TitleDiv>
                <Title>
                  {isLive ? (isEnded || isSoldOut ? 'SECONDARY SALE' : 'PRIMARY SALE') : 'UPCOMING'}
                </Title>
                {!isLive && startTime && (
                  <Ends starts>
                    {startTime.days > 0
                      ? moment(scheduledTime).format('ddd M/D').toUpperCase() +
                        ' @' +
                        moment(scheduledTime).format('h:mmA')
                      : `STARTS IN ` +
                        String(startTime.hours) +
                        'H ' +
                        String(startTime.minutes) +
                        'M ' +
                        String(startTime.seconds) +
                        'S'}
                  </Ends>
                )}
                {isLive &&
                  hasEndTime &&
                  !isEnded &&
                  endTime &&
                  primaryMint?.supply !== primaryMint?.editionMetadata?.maxSupply && (
                    <Ends>
                      {'ENDS IN ' + String(endTime.minutes) + 'M ' + String(endTime.seconds) + 'S'}
                    </Ends>
                  )}
              </TitleDiv>
              <MainStat>
                {!isEnded && !isSoldOut
                  ? `${
                      (primaryMint?.milestones?.nextMilestone ??
                        primaryMint?.editionMetadata?.maxSupply ??
                        0) - primaryMint?.supply
                    } LEFT`
                  : `${count} LISTED`}
              </MainStat>
            </HeaderDiv>
            {isTablet && (
              <TopLeftDiv>
                <MobileBuy style={mobileBuyState}>View</MobileBuy>
                <ChevronDiv style={chevronState}>
                  <ChevronUpCircle size={35} />
                </ChevronDiv>
              </TopLeftDiv>
            )}
          </TopDiv>
          <ProgressDiv>
            <InfoDiv>
              {isMaxMilestone ? (
                <NextLvl>TOTAL SUPPLY: {primaryMint?.editionMetadata?.maxSupply}</NextLvl>
              ) : !(isEnded || isSoldOut) ? (
                <HintLabel
                  hint={`NEXT MILESTONE: ${primaryMint?.milestones?.nextMilestone}`}
                  hintInfo={`If the next milestone is reached, the supply is increased by 5 and the sale is extended by another 60 minutes.`}
                  fontSize={'12px'}
                  fontWeight={'600'}
                  size={'18px'}
                  isLeftIcon
                  minWidth="225px"
                  rightAligned
                />
              ) : (
                <NextLvl>TOTAL SUPPLY: {primaryMint?.supply}</NextLvl>
              )}
            </InfoDiv>
            <BorderLinearProgress
              variant="determinate"
              value={
                (primaryMint?.supply /
                  (!(isSoldOut || isEnded)
                    ? primaryMint?.milestones?.nextMilestone ??
                      primaryMint?.editionMetadata?.maxSupply ??
                      0
                    : primaryMint?.supply ?? 0)) *
                100
              }
            />
          </ProgressDiv>
          <Divider />
          <TotalDiv>
            {!(isEnded || isSoldOut) ? (
              <PriceDiv>
                <MainStat discount={!isLive && hasAllowlist}>
                  {(
                    !isLive && hasAllowlist
                      ? allowlistDiscount === 0
                      : primaryMint?.editionMetadata?.primarySalePrice === 0
                  )
                    ? `FREE`
                    : `${
                        Math.round(
                          (((!isLive && hasAllowlist
                            ? allowlistDiscount
                            : primaryMint?.editionMetadata?.primarySalePrice) *
                            quantity) /
                            LAMPORTS_PER_SOL) *
                            100
                        ) / 100
                      } SOL`}
                </MainStat>
                <Dollars discount={!isLive && hasAllowlist}>{`$${(
                  Number(
                    ((!isLive && hasAllowlist
                      ? allowlistDiscount
                      : primaryMint?.editionMetadata?.primarySalePrice) *
                      quantity) /
                      LAMPORTS_PER_SOL
                  ) * price
                ).toFixed(2)}`}</Dollars>
              </PriceDiv>
            ) : (
              <PriceDiv>
                <MainStat>
                  {!minPrice ? '∞' : `${Math.round((minPrice / LAMPORTS_PER_SOL) * 100) / 100} SOL`}
                </MainStat>
                <Dollars>
                  {!minPrice
                    ? 'None listed'
                    : `$${(Number(minPrice / LAMPORTS_PER_SOL) * price).toFixed(2)}`}
                </Dollars>
              </PriceDiv>
            )}
            <ThemeProvider theme={theme}>
              <ButtonGroup
                variant="outlined"
                size="large"
                color="default"
                aria-label="outlined button group"
              >
                <Button disabled={quantity === 1} onClick={() => setQuantity(quantity - 1)}>
                  -
                </Button>
                <Button
                  disableTouchRipple
                  disableFocusRipple
                  disableRipple
                  disableElevation
                  style={{ backgroundColor: 'transparent', cursor: 'default' }}
                  color="default"
                >
                  {isEnded || isSoldOut ? 1 : quantity}
                </Button>
                <Button
                  disabled={
                    isEnded ||
                    isSoldOut ||
                    (!isLive && allowlistAmount > 0
                      ? quantity >= allowlistAmount - balance
                      : quantity >=
                        (primaryMint?.milestones?.nextMilestone ??
                          primaryMint?.editionMetadata?.maxSupply ??
                          0) -
                          primaryMint?.supply)
                  }
                  onClick={() => setQuantity(quantity + 1)}
                >
                  +
                </Button>
              </ButtonGroup>
            </ThemeProvider>
          </TotalDiv>
          <TotalDiv style={{ marginTop: 5, marginBottom: 15 }}>
            <Dollars style={{ color: `rgb(48, 209, 88)`, fontWeight: 600 }}>{`You own ${
              balance ?? 0
            }`}</Dollars>
            <Dollars
              style={{ cursor: `pointer` }}
              onClick={() =>
                isEnded ||
                isSoldOut ||
                (!isLive && allowlistAmount > 0
                  ? setQuantity(allowlistAmount - balance)
                  : setQuantity(
                      (primaryMint?.milestones?.nextMilestone ??
                        primaryMint?.editionMetadata?.maxSupply ??
                        0) - primaryMint?.supply
                    ))
              }
            >{`Max: ${
              isEnded || isSoldOut
                ? primaryMint?.supply
                : !isLive && allowlistAmount > 0
                ? allowlistAmount - balance
                : (primaryMint?.milestones?.nextMilestone ??
                    primaryMint?.editionMetadata?.maxSupply ??
                    0) - primaryMint?.supply
            }`}</Dollars>
          </TotalDiv>
          <ActionsDiv>
            <BuyButton
              disabled={!isLive && allowlistAmount > 0 ? allowlistAmount <= balance : false}
              // onMouseEnter={() =>
              //   !isLive && allowlistAmount > 0 && allowlistAmount <= balance
              //     ? null
              //     : setBuyHover(true)
              // }
              // onMouseLeave={() =>
              //   !isLive && allowlistAmount > 0 && allowlistAmount <= balance
              //     ? null
              //     : setBuyHover(false)
              // }
              style={buyHoverState}
              onClick={async () => {
                // if (isLive) {
                //   if (isEnded || isSoldOut) {
                //     // secondary sale
                //     if (localStorage.getItem('walletName') === '"Crossmint"') {
                //       const creator = await fbGetUserMetadata(video.created_by)
                //       const { data } = await listings.refetch()
                //       const listingsResults = data.listingWithToken
                //       if (!wallet.publicKey || !listingsResults[0].seller) {
                //         return
                //       }
                //       crossmintBuy({
                //         video,
                //         creatorName: creator?.display_name ?? getShortenedAddress(video.created_by),
                //         purchaseType: PurchaseType.SECONDARY,
                //         price: (minPrice / LAMPORTS_PER_SOL).toFixed(2),
                //         buyer: wallet.publicKey.toBase58(),
                //         seller: listingsResults[0].seller,
                //         priceLamports: minPrice,
                //         tokenSize: 1,
                //       })
                //       return
                //     }
                //     setOpen({ type: SECONDARY_ACTION.BUY, video: video })
                //   } else {
                //     buyEdition()
                //   }
                // } else if (
                //   !video.has_presale ||
                //   (video.has_presale && isAuthenticated && !hasAllowlist)
                // ) {
                //   // add to calendar
                // } else if (isAuthenticated && hasAllowlist) {
                //   if (allowlistAmount > 0 && allowlistAmount <= balance) {
                //     return
                //   } else {
                //     buyEdition(allowlistDiscount, allowlistAmount)
                //   }
                // } else {
                //   setVisible(true)
                // }
              }}
            >
              {isLive ? (
                isEnded || isSoldOut ? (
                  'Buy on Secondary'
                ) : (
                  `Buy${quantity > 1 ? ` ${quantity}` : ``} Edition${quantity > 1 ? `s` : ``}`
                )
              ) : !video.has_presale || (video.has_presale && isAuthenticated && !hasAllowlist) ? (
                <Popover
                  hideArrow
                  trigger={'click'}
                  visible={visible}
                  placement={'bottom'}
                  onVisibleChange={changeVisible}
                  style={calendarStyle}
                  content={
                    <PopoverWrapper>
                      <MenuItem
                        onClick={() =>
                          openCalendarLink(
                            {
                              title: video.title,
                              description: video.description,
                              startTime: scheduledTime ?? new Date(),
                            },
                            'apple',
                            video.address
                          )
                        }
                      >
                        <Apple />
                        <MenuItemTitle color="white">Apple Calendar</MenuItemTitle>
                      </MenuItem>
                      <MenuItem
                        onClick={() =>
                          openCalendarLink(
                            {
                              title: video.title,
                              description: video.description,
                              startTime: scheduledTime ?? new Date(),
                            },
                            'google',
                            video.address
                          )
                        }
                      >
                        <Calendar />
                        <MenuItemTitle color="white">Google Calendar</MenuItemTitle>
                      </MenuItem>
                    </PopoverWrapper>
                  }
                >
                  {'Add To Calendar'}
                </Popover>
              ) : isAuthenticated && hasAllowlist ? (
                allowlistAmount > 0 && allowlistAmount <= balance ? (
                  `Already Claimed Presale`
                ) : (
                  `Claim Presale Edition${allowlistAmount === 1 ? '' : 's'}`
                )
              ) : (
                'Check Whitelist Status'
              )}
            </BuyButton>
            {balance > 0 && (
              <SellButton
                // onMouseEnter={() => setSellHover(true)}
                // onMouseLeave={() => setSellHover(false)}
                style={sellHoverState}
                onClick={() => {
                  // const isAnyOfferOnSecondaryMarket = maxPrice !== 0
                  // if (isAnyOfferOnSecondaryMarket) {
                  //   log(new ClickSellEvent(video.address, !(isSoldOut || isEnded)))
                  // } else {
                  //   log(new ClickListForSaleEvent())
                  // }
                  // if (localStorage.getItem('walletName') === '"Crossmint"') {
                  //   crossmintSecondary({
                  //     type: SecondaryAction.LISTING,
                  //     video,
                  //   })
                  // } else {
                  //   setOpen({ type: SECONDARY_ACTION.SELL, video: video })
                  // }
                }}
              >
                Sell
              </SellButton>
            )}
          </ActionsDiv>
        </InnerDiv>
      )}
    </OuterDiv>
  )
}

export default EditionsDetails
